import axios from 'axios';
import { apiBaseUrl } from '../config/constants';
import { QueryRequest, QueryResponse } from '../utils/types';

export const query = (query: QueryRequest) => {
  return axios.post<QueryResponse>(apiBaseUrl + '/query', query);
};
